import settings from './settings';


const _console = (type, ...args) => {
  if (settings.devtools) {
    console[type](...args); // eslint-disable-line no-console
  }
};


export const consoleLog = (...args) => _console('log', ...args);


export const consoleInfo = (...args) => _console('info', ...args);


export const consoleWarn = (...args) => _console('warn', ...args);


export const consoleError = (...args) => _console('error', ...args);


export const consoleTrace = (...args) => _console('trace', ...args);


export default {
  log: consoleLog,
  info: consoleInfo,
  warn: consoleWarn,
  error: consoleError,
  trace: consoleTrace
};
